module.exports = __webpack_public_path__ + "img/kantoor.c8ef8808.jpg";